var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTShirt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shirts:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D14D75",
    d: "M602,581.4l-1.3-6.3c-3.6-14.9-6.8-26.7-12.6-41c-6.4-15.4-14.5-27.8-29.4-35.5 c-26.9-14-56.9-17.1-84.9-28.5l-10.8-4.8c-25.3,28.9-66.4,43.1-104.8,41.4c-10.1-0.5-20.2-1.9-30.1-4.4 c-26.5-6.5-51.3-19.9-70.4-39.5c-13.5,6.3-30.6,11.2-44.1,15.6c-30.9,9.9-68.5,18.1-81.2,42c-7.3,13.8-13.1,30.8-16.9,45.7 c-1.1,4.5-9.3,36.6-6.8,42.3l80.8,2.4l1.3,66.5c50.5,27,108.1,42.3,169.4,42.3c65.8,0,127.4-17.7,180.5-48.5l-7.1-75.7l68.2-11.5 C602.4,583.4,602.2,582.3,602,581.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A93458",
    points: "189.5,611 189.5,611 189.5,610.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A93458",
    d: "M189.5,609v1.1l0.2-17c0.4-11.3,0.1-18.5-0.2-29.8c-0.3-11.2,0.4-23.4-1.9-34.4 c-1.1-2.3-2.5,10.5-2.9,14.8c-0.6,6-0.9,12.1-1.5,18c-1,10.3-1.6,21.8-2.2,32.1l-1.3,16.9l9.9,0.3v-1L189.5,609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A93458",
    d: "M535.1,549.3c-1.1-5.9-2-11.9-3.1-17.8c-0.8-4.2-3.3-16.9-4.3-14.5c-1.4,11.1,0.5,23.3,1.1,34.4 c0.7,11.3,2.3,22.5,3.7,33.7l1,10.6l0,0l-0.2-2.4l0.2,2.4l8.6-1.4l-2.1-13.1C538.6,570.8,537,559.5,535.1,549.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A93458",
    points: "538.4,646.9 533.6,595.6 533.6,595.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirt3);
export default __webpack_public_path__ + "static/media/t-shirt_3.8d0d676e8536643e934e77242cbdde5a.svg";
export { ForwardRef as ReactComponent };